import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {MenuService} from '../../../services/menu.service';
import {ModuleService} from '../../../services/module.service';
import {PermissionService} from '../../../services/permission.service';

@Component({
  selector: 'app-submenu-add',
  templateUrl: './submenu-add.component.html',
  styleUrls: ['./submenu-add.component.scss']
})
export class SubmenuAddComponent implements OnInit{

  menuForm: FormGroup;
  modules: any[] = [];
  childrens: any[] = [];
  parentsFiltered: any[] = [];
  permissions: any[] = [];

  loading = 'Loading...';

  public types: any[] = [
    {id: 1, name: 'link', title: 'submenu'},
  ];
  moduleSelected: number | undefined;
  categorySelected: number | string | undefined;
  childrenSelected: number | undefined;
  permissionSelected: number | undefined;

  saving = false;

  public data: any;

  isSubmitted = false;
  val: any | null;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private menuService: MenuService,
              private moduleService: ModuleService,
              private permissionService: PermissionService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.menuForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      path: [''],
      type: ['', [Validators.required]],
      module: ['', [Validators.required]],
      parent: ['', [Validators.required]],
      position: null,
      permission: null,
      title: this.types[0]["title"],
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.menuForm.get('isEnable')?.setValue('1');
    console.log(this.menuForm);
    this.menuForm.patchValue(this.data);
    // if (this.data){
    //   this.moduleSelected = this.data.module['@id'];
    //   this.childrenSelected = this.data.children['@id'];
    //   this.categorySelected = this.data.category.id;
    //   this.permissionSelected = this.data.permission['@id'];
    // }
    this.findAllModule();
    this.findAllMenu();
    this.findAllPermissions()

    this.categorySelected = 'link';

  }

  get fc(): any {
    return this.menuForm.controls;
  }

  changeVal(value: any): void{
    this.val = value;
    console.log(this.val);
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    if (this.menuForm.valid){
      this.saving = true;
      console.log(this.menuForm.value);

      // if (this.menuForm.get('parent').value === '' || this.menuForm.get('parent').value === undefined){
      //   console.log(this.menuForm.get('parent'));
      //   this.menuForm.get('parent').setValue(null);
      // }
      this.menuForm.get('isEnable')?.setValue(this.menuForm.get('isEnable')?.value === '1');
      this.menuService.postSubMenu(this.menuForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Menu create with success !', 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            console.log(err);
            const errors: any[] = err.violations;

            if (errors){
              errors.forEach((v) =>
              {
                if (v.propertyPath === 'type'){
                  this.menuForm.get('category')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'module'){
                  this.menuForm.get('module')?.setErrors({serverError: v.message});
                }
                console.log(v.message);
                if (v.propertyPath === 'name'){
                  this.menuForm.get('name')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'position'){
                  this.menuForm.get('position')?.setErrors({serverError: v.message});
                }

                this.saving = false;

              });
            }
            else {
              this.saving = false;
              this.toastr.error(err['hydra:title'], 'Error');
            }

            // this.menuForm.get('name')?.setErrors({serverError: err['hydra:description']});
            // this.saving = false;

          }
        });

    }
  }

  findAllModule(): any{
    this.moduleService.getEnableCollection().subscribe((data: any) => {
          this.modules = data['hydra:member'];
          this.modules = this.modules.map((v) => {
            v.id = v['@id'];
            console.log(v['@id']);
            return v;
          });
        },
        error => console.log(error)
    );
  }

  applyModuleFilter(event: any): void{
    console.log('BJR');
    // this.parentsFiltered = this.childrens.filter((childrens: any) => childrens.module['@id'] === this.moduleSelected);
    this.parentsFiltered = this.childrens.filter((childrens: any) => childrens.module === this.moduleSelected);
  }


  findAllMenu(): any{
    //this.menuService.getMenuList().subscribe((data: any) => {
    this.menuService.getCollectionParent().subscribe((data: any) => {
          this.childrens = data['hydra:member'];
          console.log(this.childrens);
          this.childrens = this.childrens.map((v) => {
            v.id = v['@id'];
            console.log(v['@id']);
            return v;
          });
        },
        error => console.log(error)
    );
  }

  findAllPermissions(): any{
    this.permissionService.getEnableCollection().subscribe((data: any) => {
          this.permissions = data['hydra:member'];
          this.permissions = this.permissions.map((v) => {
            v.id = v['id'];
            console.log(v['@id']);
            return v;
          });
        },
        error => console.log(error)
    );
  }


}
